import { createFileRoute } from '@tanstack/react-router'

import { SigningPage } from '@/features/public-signing/signing-page'

/**
 * The customer's signing link, `/s/<token>`.
 *
 * Outside `_app` on purpose: no auth guard, no app shell, no bottom nav, no dealership header.
 * The token is the whole of the URL's payload — no id, no name, nothing about a licence — and
 * the API resolves the dealership from its hash, so this route has nothing to look up before it
 * renders and nothing to redirect to when there is no session.
 */
export const Route = createFileRoute('/s/$token')({
  component: PublicSigningRoute,
})

function PublicSigningRoute() {
  const { token } = Route.useParams()
  // A different link is a different page: the key throws away the previous one's cache and
  // state rather than showing one customer's agreement while the next one's loads.
  return <SigningPage key={token} token={token} />
}
